import { useMemo } from 'react';
import { buildCapabilitiesFromConfig, buildFormattingTrayFromConfig } from './utils/buildCapabilitiesFromConfig';
import styled from 'styled-components';
import { SubmitButtonContext } from './contexts/SubmitButtonContext';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledWrapper = styled.div.withConfig({
  displayName: "ProsemirrorMenu__StyledWrapper"
})(["padding-top:", ";"], ({
  theme
}) => theme.space['200']);
export default function ProsemirrorMenu(props) {
  const {
    editorConfig,
    menuClassName = '',
    submitButton
  } = props;
  const memoizedSubmitButton = useMemo(() => {
    return {
      submitButton
    };
  }, [submitButton]);
  const toolbarCapabilities = useMemo(() => {
    return buildCapabilitiesFromConfig(editorConfig);
  }, [editorConfig]);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledWrapper, {
      className: `prosemirror-controls ${menuClassName}`,
      children: /*#__PURE__*/_jsx(SubmitButtonContext.Provider, {
        value: memoizedSubmitButton,
        children: /*#__PURE__*/_jsx(TFlex, {
          alignItems: "center",
          flexWrap: "wrap",
          children: toolbarCapabilities
        })
      })
    })
  );
}
export function ProsemirrorFormattingTray(props) {
  const {
    editorConfig,
    menuClassName = ''
  } = props;
  const formattingToolbarCapabilities = useMemo(() => {
    return buildFormattingTrayFromConfig(editorConfig);
  }, [editorConfig]);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledWrapper, {
      className: `prosemirror-formatting-tray ${menuClassName}`,
      children: /*#__PURE__*/_jsx(TFlex, {
        alignItems: "center",
        flexWrap: "wrap",
        children: formattingToolbarCapabilities
      })
    })
  );
}